import cookieInfo from '@alife/bc-cookie-info';

export function checkIsLogged() {
  //是否登陆; 获取最新的 isLoggedIn 状态
  return cookieInfo.getIsLoggedIn();
}

// type xman_us_t = 'ctoken' | 'l_source' | 'need_popup' | 'sign' | 'x_lid' | 'x_user';
export function getCToken() {
  //用户登陆后cookie才有‘xman_us_t’字段，当中包含了ctoken
  const value = cookieInfo.getCookie('xman_us_t') || '';
  const list = parser(value);
  return list.ctoken || '';
}

export function getCsrfToken() {
  const value = cookieInfo.getCookie('_csrf_token') || '';
  return value;
}

const parser = function parser(raw: string) {
  const result: { [key: string]: string } = {};
  if (!raw) return result;
  const list = raw.split('&');

  list.map((current: string) => {
    const arr = current.split('=');
    const key = arr[0];
    const value = arr[1];
    result[key] = value;
  });

  return result;
};
